module.exports = __webpack_public_path__ + "static/media/tournaments-history-menu-icon.574f59e8.svg";